import { render, staticRenderFns } from "./viewList.vue?vue&type=template&id=1d156390&"
import script from "./viewList.vue?vue&type=script&lang=js&"
export * from "./viewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports